import { render, staticRenderFns } from "./sdjnDetail.vue?vue&type=template&id=774e1111&scoped=true&"
import script from "./sdjnDetail.vue?vue&type=script&lang=js&"
export * from "./sdjnDetail.vue?vue&type=script&lang=js&"
import style0 from "./sdjnDetail.vue?vue&type=style&index=0&id=774e1111&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774e1111",
  null
  
)

export default component.exports